import { render, staticRenderFns } from "./TheDeleteCategoryModal.vue?vue&type=template&id=3d555c66&scoped=true&"
import script from "./TheDeleteCategoryModal.vue?vue&type=script&lang=js&"
export * from "./TheDeleteCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./TheDeleteCategoryModal.vue?vue&type=style&index=0&id=3d555c66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d555c66",
  null
  
)

export default component.exports